import React from "react"
import { useTranslation } from "react-i18next"
import { SMALL } from "constants/index"
import CTA from "components/atoms/CTA"

type WishamPropButtonProps = {
  repurchase?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export default function WishamProButton(props: WishamPropButtonProps) {
  const { repurchase = false, onClick } = props
  const { t } = useTranslation()

  function handleClick(event: React.MouseEvent<HTMLButtonElement>) {
    if (typeof onClick === "function") {
      onClick(event)
    }
  }

  return <CTA
    variant="contained"
    size={SMALL}
    style={{ width: "fit-content" }}
    onClick={handleClick}
  >
    {repurchase ? t("premium.repurchaseSubscription") : t("premium.pro")}
  </CTA>
}
